<template>
  <div class="c-message c-message--fridayrush c-content" data-message-type="fridayrush">
    <h3 class="c-col__heading-4">Friday Rush</h3>
    <div class="c-message__content" v-html="output"></div>
    <Countdown v-if="activeStartTime > preSaleStartTime" :launch-date="parseInt(activeStartTime)" />
  </div>
</template>

<script>
import Countdown from "../Countdown";
export default {
  name: "Fridayrush",
  components: {
    Countdown,
  },
  props: ['content'],
  data() {
    return {
      output: '',
      preSaleStartTime: false,
      activeStartTime: false,
    }
  },
  mounted() {
    this.renderContent()
  },
  methods: {
    renderContent() {
      this.output = this.content.message
      this.preSaleStartTime = this.content.startDateTime
      this.activeStartTime = this.content.activeDateTime
    }
  }
}
</script>
